import { GetterTree } from "vuex";
import * as types from "@/store/constants/types";
import GeneralUtilsHelper from "@/utils/generalUtils";
import SuperPayAndBackUpHelpers, {
  TEMP_KEY,
  LOCAL_KEY,
  RECORD_KEY
} from "@/utils/superPayAndBackUp";
import { findLastIndex } from "lodash";

const Getters: GetterTree<any, any> = {
  [types.GETTER_BACK_UP_APP_CONFIG](state) {
    return state.backUpAppConfig;
  },
  [types.GETTER_BACK_UP_APP_SHOW_ENABLE](state) {
    return state.backUpAppShowEnable;
  },
  [types.GETTER_BACK_UP_APP_HAS_INSTALLED](state) {
    return state.backUpAppConfig && state.backUpAppConfig.has_install;
  },
  [types.GETTER_BACK_UP_APP_INSTALLED_STATUS](state) {
    return state.backUpAppInstalled;
  },
  [types.GETTER_BACK_UP_APP_LAUNCH_SHOW_ENABLE](state, getters) {
    return () => {
      return false;
    };
  },
  [types.GETTER_BACK_UP_PAY_RESULT_PAGE_SHOW_ENABLE](state, getters) {
    return () => {
      if (getters[types.GETTER_BACK_UP_APP_SHOW_ENABLE]) {
        //支付显示的队列数组:
        const payResultRecordQueue: any = SuperPayAndBackUpHelpers.getLocalKeyTimes(
          RECORD_KEY.PAY_RESULT_SUPER_OR_BACK_RECOMMEND_SHOW_RECORD
        );
        //setting:
        const settingData: any = getters[types.GETTER_SETTING_DATA];
        console.log("payResultRecordQueue:", payResultRecordQueue);
        //suer pay index:
        const findLastSuperPayIndex = findLastIndex(
          payResultRecordQueue,
          (record: string) => {
            return record === "super_pay";
          }
        );
        //back up index:
        const findLastBackUpIndex = findLastIndex(
          payResultRecordQueue,
          (record: string) => {
            return record === "back_up";
          }
        );
        //superpay continus throld:
        const superPayContinusThrold =
          settingData.super_pay.pay_result_page.continuous_show_times;
        //superpay  continus
        const suerPayContinusTimes = GeneralUtilsHelper.findContinusTimesShowName(
          "super_pay",
          "back_up",
          payResultRecordQueue
        );

        //backup continus throld:
        const backUpContinusThrold =
          settingData.back_up.pay_result_page.continuous_show_times;
        //back up continus
        const backUpContinusTimes = GeneralUtilsHelper.findContinusTimesShowName(
          "back_up",
          "super_pay",
          payResultRecordQueue
        );

        //spcacing times:
        let spacingTimes: any =
          settingData.back_up.pay_result_page.spacing_show_times;

        console.log("GETTER_BACK_UP_PAY_RESULT_PAGE_SHOW_ENABLE:", {
          payResultRecordQueue,
          superPayContinusThrold,
          backUpContinusThrold,
          findLastSuperPayIndex,
          findLastBackUpIndex,
          suerPayContinusTimes,
          backUpContinusTimes
        });

        if (!getters[types.GETTER_SUPER_PAY_SHOW_ENABLE]) {
          //super pay达不到条件
          console.log("super pay达不到条件");
          spacingTimes =
            settingData.back_up.pay_result_page.spacing_show_times_single;
          if (findLastBackUpIndex === -1) {
            console.log("findLastBackUpIndex ==-1");
            return true;
          } else if (
            payResultRecordQueue.length - 1 - findLastBackUpIndex ===
            spacingTimes
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          //两个同时显示:
          //1.back up 在末尾
          //2.superpay 在末尾
          if (findLastSuperPayIndex > findLastBackUpIndex) {
            //有super pay在末尾
            console.log("有super pay在末尾");
            if (
              suerPayContinusTimes >= superPayContinusThrold &&
              payResultRecordQueue.length - 1 - findLastSuperPayIndex ===
                spacingTimes
            ) {
              //检查superpay是否达到连续，间隔是否达到
              return true;
            } else {
              return false;
            }
          } else if (findLastBackUpIndex > findLastSuperPayIndex) {
            //back up 在末尾，检查backup连续性
            console.log("back up 在末尾，检查backup连续性");
            if (
              backUpContinusTimes < backUpContinusThrold &&
              payResultRecordQueue.length - 1 - findLastBackUpIndex ===
                spacingTimes
            ) {
              //检查back ups是否达到连续，间隔是否达到
              return true;
            } else {
              return false;
            }
          } else {
            //index相等，一种情况就是都为0: back up 优先级太低
            console.log("index相等，一种情况就是都为0:");
            return false;
          }
        }
      } else {
        return false;
      }
    };
  },
  [types.GETTER_BACK_UP_PAY_RESULT_PAGE_CLOSE_SHOW_ENABLE](state, getters) {
    return () => {
      if (getters[types.GETTER_BACK_UP_APP_SHOW_ENABLE]) {
        //支付显示的队列数组:
        const payResultRecordQueue: any = SuperPayAndBackUpHelpers.getLocalKeyTimes(
          RECORD_KEY.PAY_RESULT_PAGE_CLOSE_SUPER_OR_BACK_DIALOG_SHOW_RECORD
        );
        //setting:
        const settingData: any = getters[types.GETTER_SETTING_DATA];
        console.log("payResultRecordQueue:", payResultRecordQueue);
        //suer pay index:
        const findLastSuperPayIndex = findLastIndex(
          payResultRecordQueue,
          (record: string) => {
            return record === "super_pay";
          }
        );
        //back up index:
        const findLastBackUpIndex = findLastIndex(
          payResultRecordQueue,
          (record: string) => {
            return record === "back_up";
          }
        );
        //superpay continus throld:
        const superPayContinusThrold =
          settingData.super_pay.pay_result_close.continuous_show_times;
        //superpay  continus
        const suerPayContinusTimes = GeneralUtilsHelper.findContinusTimesShowName(
          "super_pay",
          "back_up",
          payResultRecordQueue
        );

        //backup continus throld:
        const backUpContinusThrold =
          settingData.back_up.pay_result_close.continuous_show_times;
        //back up continus
        const backUpContinusTimes = GeneralUtilsHelper.findContinusTimesShowName(
          "back_up",
          "super_pay",
          payResultRecordQueue
        );

        //spcacing times:
        let spacingTimes: any =
          settingData.back_up.pay_result_close.spacing_show_times;

        console.log("GETTER_BACK_UP_PAY_RESULT_PAGE_SHOW_ENABLE:", {
          payResultRecordQueue,
          superPayContinusThrold,
          backUpContinusThrold,
          findLastSuperPayIndex,
          findLastBackUpIndex,
          suerPayContinusTimes,
          backUpContinusTimes
        });

        if (!getters[types.GETTER_SUPER_PAY_SHOW_ENABLE]) {
          //super pay达不到条件
          console.log("super pay达不到条件");
          spacingTimes =
            settingData.back_up.pay_result_close.spacing_show_times_single;
          if (findLastBackUpIndex === -1) {
            console.log("findLastBackUpIndex ==-1");
            return true;
          } else if (
            payResultRecordQueue.length - 1 - findLastBackUpIndex ===
            spacingTimes
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          //两个同时显示:
          //1.back up 在末尾
          //2.superpay 在末尾
          if (findLastSuperPayIndex > findLastBackUpIndex) {
            //有super pay在末尾
            console.log("有super pay在末尾");
            if (
              suerPayContinusTimes >= superPayContinusThrold &&
              payResultRecordQueue.length - 1 - findLastSuperPayIndex ===
                spacingTimes
            ) {
              //检查superpay是否达到连续，间隔是否达到
              return true;
            } else {
              return false;
            }
          } else if (findLastBackUpIndex > findLastSuperPayIndex) {
            //back up 在末尾，检查backup连续性
            console.log("back up 在末尾，检查backup连续性");
            if (
              backUpContinusTimes < backUpContinusThrold &&
              payResultRecordQueue.length - 1 - findLastBackUpIndex ===
                spacingTimes
            ) {
              //检查back ups是否达到连续，间隔是否达到
              return true;
            } else {
              return false;
            }
          } else {
            //index相等，一种情况就是都为0: back up 优先级太低
            console.log("index相等，一种情况就是都为0:");
            return false;
          }
        }
      } else {
        return false;
      }
    };
  },
  [types.GETTER_BACK_UP_DELIVER_CLOSE_TOAST_SHOW_ENABLE](state, getters) {
    return () => {
      //第一次必出，然后隔对应次数出：
      if (getters[types.GETTER_BACK_UP_APP_SHOW_ENABLE]) {
        const settingData: any = getters[types.GETTER_SETTING_DATA];
        const spacingTimes =
          settingData.back_up.arrival_dialog.close_spacing_show_times;
        const localDeliverToastCloseTimes = SuperPayAndBackUpHelpers.getLocalKeyTimes(
          LOCAL_KEY.LOCAL_DELIVER_TOAST_CLOSE_TIMES
        );
        if (
          localDeliverToastCloseTimes <= 1 ||
          (localDeliverToastCloseTimes - 1) % (spacingTimes + 1) === 0
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    };
  },
  [types.GETTER_BACK_UP_DELIVER_RECOMMEND_SHOW_ENABLE](state, getters) {
    return () => {
      //第一次必出,然后隔对应次数出:
      if (getters[types.GETTER_BACK_UP_APP_SHOW_ENABLE]) {
        const settingData: any = getters[types.GETTER_SETTING_DATA];
        const spacingTimes =
          settingData.back_up.arrival_dialog.spacing_show_times;
        const localDeliverToastShowTimes = SuperPayAndBackUpHelpers.getTempKeyTimes(
          TEMP_KEY.TEMP_DELIVER_TOAST_SHOW_TIMES
        );
        if (
          localDeliverToastShowTimes <= 1 ||
          (localDeliverToastShowTimes - 1) % (spacingTimes + 1) === 0
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    };
  },
  [types.GETTER_BACK_UP_APP_SHOW_OTHER_CONDITION](state, getters, rootState) {
    //启动次数和时间差：
    //先判断是否seting:
    return () => {
      const settingData: any = getters[types.GETTER_SETTING_DATA];
      const launchTime: number = getters[types.GETTER_APP_LAUNCH_TIME];
      const fistLaunchTimeStamp: number =
        getters[types.GETTER_FIRST_ENTER_TIMESTAMP];
      const nowTimeStamp = new Date().valueOf();
      let params: any = {};
      if (settingData.back_up && settingData.back_up.show_qualification) {
        params = settingData.back_up.show_qualification;
      } else {
        //默认参数:
        params = {
          interval: 12 * 60 * 60, //12h
          open_app: 2
        };
      }

      if (getters[types.GETTER_APP_TAKE_DOWN]) {
        // 如果下架了 直接返回true
        return true;
      }

      if (
        launchTime >= params.open_app &&
        nowTimeStamp - fistLaunchTimeStamp >= params.interval * 1000
      ) {
        console.log("GETTER_BACK_UP_APP_SHOW_OTHER_CONDITION 成功:", {
          difftime: nowTimeStamp - fistLaunchTimeStamp,
          launchTime
        });
        return true;
      } else {
        console.log("GETTER_BACK_UP_APP_SHOW_OTHER_CONDITION 失败:", {
          difftime: nowTimeStamp - fistLaunchTimeStamp,
          launchTime
        });
        return false;
      }
    };
  }
};
export default Getters;
